import { Grid2, TextField } from "@mui/material";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useEffect, useMemo } from "react";
import useUIBp from "../../../Hooks/useUIBoilerplate";
import { UIactions } from "../../../store/slices/UI";
import { defaultDatetime } from "./genericIDs";

const DateTime = ({
  id = defaultDatetime,
  disabled,
  size = 12,
  componentSize = "small",
  clearOnUnmount,
  maxDateTime,
  UIText,
  noDefault,
  emptyStart,
}) => {
  const { dispatch, UI, settings } = useUIBp();
  const field = useMemo(() => UI[id], [UI, id]);
  const { label } = UIText[settings.locale];

  useEffect(() => {
    if (emptyStart && !field) {
      console.log("Empty start");
      dispatch(UIactions.setField({ id, value: null }));
    } else if (!field && !noDefault) {
      dispatch(UIactions.setField({ id, value: dayjs() }));
    }
  }, [dispatch, field, id, noDefault, emptyStart]);

  useEffect(() => {
    return () => {
      if (clearOnUnmount) {
        dispatch(UIactions.clear(id));
      }
    };
  }, [dispatch, clearOnUnmount, id]);

  const handleChange = (value, err) => {
    dispatch(UIactions.setField({ id, value }));
  };

  const handleError = (err) => {
    if (field?.value === null) {
      dispatch(UIactions.setFieldError({ id, value: null }));
    }else if (!!err) {
      dispatch(UIactions.setFieldError({ id, value: err }));
    }
  };

  let value 

  if (emptyStart && field?.value === null) {
    value = null;
  } else {
    value = !!field ? dayjs(field.value) : dayjs()
  }

  return (
    <Grid2 container {...{ size }}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateTimePicker
          {...{
            ampm: false,
            disabled,
            size: componentSize,
            onChange: handleChange,
            value,
            maxDateTime,
            sx: { width: "100%" },
            formatDensity: "dense",
            slots: { textField: TextField },
            
            onError: handleError,
            slotProps: {
              textField: {
                label,
                size: componentSize,
                sx: { width: "100%" },
              },
            },
          }}
        />
      </LocalizationProvider>
    </Grid2>
  );
};

export default DateTime;
